<template>
  <div id="App">
    <van-nav-bar
      :title="tempPro.Name"
      :left-text="showReturn ? '返回' : ''"
      :left-arrow="showReturn"
      @click-left="onClickLeft"
    />
    <van-tabs swipeable @change="onLoad" animated v-model="dayActive">
      <van-tab
        v-for="index in 31"
        :key="index"
        :name="index"
        :title="getTitle(index)"
      >
        <van-list
          style="margin-top: -15px"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad()"
        >
          <van-divider />
          <van-cell
            v-for="item in list"
            :key="item.CODE"
            :title="item.NAME"
            :label="
              '总人数:' +
              item.ZRS +
              '; 在现场:' +
              item.ZXC +
              '; 已离场:' +
              item.YLC +
              '; 未入场:' +
              item.WRC +
              ';'
            "
            is-link
            size="large"
            @click="onClickCell(item)"
          />
        </van-list>
      </van-tab>
    </van-tabs>
    <Tabbar></Tabbar>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Tabbar from "@/components/Tabbar.vue";
import { Dialog } from "vant";
export default {
  data() {
    return {
      showReturn: true,
      dayActive: 1,
      list: [],
      loading: false,
      finished: false,
      pro: {
        Code: '',
        Name: '',
      },
      loadingTimes: 0,
    };
  },
  components: {
    Tabbar,
  },
  computed: {
    ...mapState(["userInfo", "tempPro", "tempDayActive"]),
  },
  methods: {
    getTitle(index) {
      var newDate = new Date(Date.now() - (index - 1) * 24 * 60 * 60 * 1000);
      return newDate.getMonth() + 1 + "/" + newDate.getDate();
    },
    onClickLeft() {
      console.log("返回");
      this.$router.go(-1);
    },
    onClickCell(key) {
      this.$router.push({
        path: "/showworkerlist",
        name: "ShowWorkerList",
        query: {
          Code: key.CODE,
          Name: key.NAME,
        },
      });
    },
    onLoad() {
      this.loading = true;
      var that = this;
      if (that.loadingTimes == 0) {
        that.loadingTimes = 1;
        if (typeof that.$route.query.Code === "undefined") {
          that.pro = that.tempPro;
          if(that.dayActive != that.tempDayActive)
          {
            that.dayActive = that.tempDayActive;
            return;
          }
        }
        else{
          that.pro = that.$route.query;
        }
      }
      that.$store.commit("setTempPro", that.pro);
      that.$store.commit("setTempDayActive", that.dayActive);
      var newDate = new Date(
        Date.now() - (that.tempDayActive - 1) * 24 * 60 * 60 * 1000
      );

      that.$axios({
        method: "post",
        url: "/api/Main",
        data: {
          Method: "GetWechatTeamList",
          Params: [
            that.userInfo.userCardID,
            that.tempPro.Code,
            that.userInfo.loginType,
            newDate.getFullYear() +
              "-" +
              (newDate.getMonth() + 1) +
              "-" +
              newDate.getDate(),
          ],
        },
        headers: {
          Authorization: "Bearer " + that.userInfo.token,
        },
      })
        .then((response) => {
          if (response.data.status == "200") {
            that.list = response.data.Table;
            that.finished = true;
          } else {
            Dialog({ message: response.data.msg });
            that.finished = true;
          }
        })
        .catch((error) => {
          console.log(error);
          //弹出失败提醒
          Dialog({ message: error.message });
          that.finished = true;
        });
    },
  },
};
</script>
